module.exports = __webpack_public_path__ + "static/media/project7.4e58ddf0.png";